/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-namespace */
import { customElement } from 'solid-element';
import ConfirmPopup, { ConfirmPopupProps } from './ConfirmPopup';
import { noShadowDOM } from 'component-register';

// TypeScript declaration for the web component
declare module 'solid-js' {
  namespace JSX {
    interface IntrinsicElements {
      'tc-confirm-popup': Partial<HTMLElement> &
        ConfirmPopupProps &
        Partial<{ ref: (el: HTMLElement | null) => void }>;
    }
  }
}

export function defineSolidConfirmPopup(): void {
  customElement(
    'tc-confirm-popup',
    {
      // Include ALL component properties with default values here
      // This is CRITICAL for proper property synchronization
      show: false,
      waiting: false,
      title: undefined,
      description: undefined,
      hideClose: false,
      primaryBtnLabel: undefined,
      primaryBtnClass: undefined,
      secondaryBtnLabel: undefined,
      secondaryBtnClass: undefined,
      overlayClass: undefined,
      onClose: undefined,
      onAction: undefined,
    },
    (props, { element }) => {
      noShadowDOM();

      function handleClose(): void {
        const evt = new CustomEvent('confirm-popup-close', {
          composed: true,
        });
        element.renderRoot.dispatchEvent(evt);
      }

      function handleAction(): void {
        const evt = new CustomEvent('confirm-popup-action', {
          composed: true,
        });
        element.renderRoot.dispatchEvent(evt);
      }

      return (
        <ConfirmPopup
          show={props.show}
          waiting={props.waiting}
          title={props.title}
          description={props.description}
          hideClose={props.hideClose}
          primaryBtnLabel={props.primaryBtnLabel}
          primaryBtnClass={props.primaryBtnClass}
          secondaryBtnLabel={props.secondaryBtnLabel}
          secondaryBtnClass={props.secondaryBtnClass}
          overlayClass={props.overlayClass}
          onClose={handleClose}
          onAction={handleAction}
        />
      );
    }
  );
}
